import { Give, GIVE_STATUS } from 'src/commons/types';
import { getYears } from 'src/commons/utils/DateUtils';

import { useGetDonorFirstGive, useGetGives } from './queries';

export function useGetYearsSinceFirstGive(
  donorId: string,
  isDescending = false
) {
  const { data: donorFirstGive, isLoading: isFirstGiveLoading } =
    useGetDonorFirstGive(donorId);
  const { data: allGivesData, isLoading: isGivesLoading } = useGetGives({
    donorId,
    status: GIVE_STATUS.PROCESSED,
  });

  function getGiveYears() {
    const allPossibleYears = getYears(getFirstGiveDate(), new Date());

    if (!allGivesData?.data || isGivesLoading) {
      return isDescending ? allPossibleYears.reverse() : allPossibleYears;
    }

    const yearsWithGives = getYearsWithGives(allGivesData.data);

    if (isDescending) {
      return yearsWithGives.reverse();
    }

    return yearsWithGives;
  }

  function getYearsWithGives(gives: Give[]): number[] {
    const uniqueGiveYears = new Set<number>();

    gives.forEach((give) => {
      if (give.giveDate) {
        const giveYear = new Date(give.giveDate).getFullYear();
        uniqueGiveYears.add(giveYear);
      }
    });

    return Array.from(uniqueGiveYears).sort((a, b) => a - b);
  }

  function getFirstGiveDate() {
    if (donorFirstGive?.giveDate) {
      return new Date(donorFirstGive.giveDate);
    } else {
      return new Date();
    }
  }

  return {
    isLoading: isFirstGiveLoading || isGivesLoading,
    giveYears: getGiveYears(),
  };
}
